import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/usr/src/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Ackodrive/ArticleListingByTopic/index.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/Ackodrive/common/AD2BottomNav/BottomNavigation/BottomNavigation.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Ackodrive/common/AD2BottomNav/BottomNavItem/BottomNavItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["range"] */ "/usr/src/app/src/components/Ackodrive/common/utils.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Ackodrive/footer/globalFooter.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/Ackodrive/header/Header.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Ackodrive/header/headerClientWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Ackodrive/header/headerNav/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Ackodrive/header/searchComponent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Ackodrive/header/topSearch/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CityProvider"] */ "/usr/src/app/src/context/CityContext/CityContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/usr/src/app/src/context/ModalContext/ModalContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/usr/src/app/src/context/UserContext/UserContenxt.tsx");
